/**
 * <TutorPrescriptionSkeleton> — la forme de « Travail entre les lives » pendant son premier chargement.
 *
 * Le cas courant : un cours partagé à deux élèves présents. Chaque carte garde sa vraie surface —
 * l'élève, « Déjà à faire » et une ligne, « À ajouter » et deux lignes (`<ActivityRowSkeleton>`),
 * puis le pied et son bouton (`pushButtonBoxHeight`). L'en-tête de Sam et « Pour qui ? » ne
 * dépendent d'aucune donnée : ils restent tels quels (`<TutorPrescriptionIntro>`).
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { pushButtonBoxHeight } from "../../atoms/Buttons/Button/Button"
import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { SectionLabel } from "../../atoms/typography/SectionLabel"
import { ActivityRowSkeleton } from "../../molecules/ActivityRow/ActivityRowSkeleton"
import { Card } from "../../molecules/Card"
import { CardListRow } from "../../molecules/CardList"
import { TutorPrescriptionIntro } from "./TutorPrescriptionIntro"

/** Deux élèves présents : un cours partagé ordinaire. */
const STUDENTS = [0, 1]

export function TutorPrescriptionSkeleton() {
    return (
        <Stack gap="3">
            <TutorPrescriptionIntro />
            {STUDENTS.map((index) => (
                <Card key={index} p="0">
                    <CardListRow>
                        <Row gap="3" align="center">
                            <Skeleton shape="circle" size={40} />
                            <Stack gap="1" style={styles.grow}>
                                <Skeleton textSize="text-lg" width={110} />
                                <Skeleton textSize="text-sm" width={32} />
                            </Stack>
                        </Row>
                    </CardListRow>
                    <CardListRow divided py="2">
                        <SectionLabel>Déjà à faire</SectionLabel>
                    </CardListRow>
                    <ActivityRowSkeleton divided titleWidth={110} />
                    <CardListRow divided py="2">
                        <SectionLabel>À ajouter</SectionLabel>
                    </CardListRow>
                    <ActivityRowSkeleton divided />
                    <ActivityRowSkeleton divided titleWidth={120} />
                    <CardListRow divided>
                        <Row justify="end">
                            <Skeleton shape="block" width={150} height={pushButtonBoxHeight()} />
                        </Row>
                    </CardListRow>
                </Card>
            ))}
        </Stack>
    )
}

const styles = StyleSheet.create(() => ({
    grow: { flex: 1 },
}))
